import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import Home from '@/Pages/Home';
import About from '@/Pages/About';
import Contact from '@/Pages/Contact';
import Faq from '@/Pages/Faq';
import Partners from '@/Pages/Partners';
import Careers from '@/Pages/Careers';
import Security from '@/Pages/Security';
import TradingHours from '@/Pages/TradingHours';
import AdvantagesOfForex from '@/Pages/AdvantagesOfForex';
import WhyTefFunded from '@/Pages/WhyTefFunded';

import PlatformOverview from '@/Pages/Platform/Overview';
import PlatformWeb from '@/Pages/Platform/Web';
import PlatformDesktop from '@/Pages/Platform/Desktop';
import PlatformMobile from '@/Pages/Platform/Mobile';

import FundingOverview from '@/Pages/Funding/Overview';
import FundingRules from '@/Pages/Funding/Rules';
import TradingRules from '@/Pages/Trading/Rules';

import EconomicCalendar from '@/Pages/Tools/EconomicCalendar';
import News from '@/Pages/Tools/News';
import TechnicalAnalysis from '@/Pages/Tools/TechnicalAnalysis';
import Calculators from '@/Pages/Tools/Calculators';

import TermsAndConditions from '@/Pages/Legal/TermsAndConditions';
import PrivacyPolicy from '@/Pages/Legal/PrivacyPolicy';
import RiskDisclosure from '@/Pages/Legal/RiskDisclosure';
import AmlKycPolicy from '@/Pages/Legal/AmlKycPolicy';
import ClientAgreement from '@/Pages/Legal/ClientAgreement';
import CookiePolicy from '@/Pages/Legal/CookiePolicy';

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [pathname]);
    return null;
}

export function AppRouter() {
    return (
        <>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/partners" element={<Partners />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/security" element={<Security />} />
                <Route path="/trading-hours" element={<TradingHours />} />
                <Route path="/advantages-of-forex" element={<AdvantagesOfForex />} />
                <Route path="/why-tef-funded" element={<WhyTefFunded />} />

                <Route path="/platform/overview" element={<PlatformOverview />} />
                <Route path="/platform/web" element={<PlatformWeb />} />
                <Route path="/platform/desktop" element={<PlatformDesktop />} />
                <Route path="/platform/mobile" element={<PlatformMobile />} />

                <Route path="/funding/overview" element={<FundingOverview />} />
                <Route path="/funding/rules" element={<FundingRules />} />
                <Route path="/trading/rules" element={<TradingRules />} />

                <Route path="/tools/economic-calendar" element={<EconomicCalendar />} />
                <Route path="/tools/news" element={<News />} />
                <Route path="/tools/technical-analysis" element={<TechnicalAnalysis />} />
                <Route path="/tools/calculators" element={<Calculators />} />

                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/risk-disclosure" element={<RiskDisclosure />} />
                <Route path="/aml-kyc-policy" element={<AmlKycPolicy />} />
                <Route path="/client-agreement" element={<ClientAgreement />} />
                <Route path="/cookie-policy" element={<CookiePolicy />} />

                {/* Fallback */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </>
    );
}
